import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider } from '@mui/material';
import { initShipstationTab } from '../../../store/thunks/shipstationShipmentThunks';
import ShipstationCategoryMenu from './ShipstationCategoryMenu';
import ShipstationPresetTabs from './ShipstationPresetTabs';
import ShipstationFacilityTabs from './ShipstationFacilityTabs';
import ShipstationShipmentToolbar from './ShipstationShipmentToolbar';
import ShipstationShipmentTable from './ShipstationShipmentTable';

const ShipstationShipmentsView = () => {
  const dispatch = useDispatch();
  const { activeCategory } = useSelector(({ shipstationShipment }) => shipstationShipment);

  useEffect(() => {
    dispatch(initShipstationTab());
  }, [dispatch]);

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      {/* Left: Category Menu */}
      <Box
        sx={{
          width: 240,
          minWidth: 240,
          borderRight: 1,
          borderColor: 'divider',
          overflow: 'auto',
        }}
      >
        <ShipstationCategoryMenu />
      </Box>

      {/* Right: Content Area */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        {activeCategory === 'awaitingShipment' && <ShipstationPresetTabs />}
        {activeCategory === 'shipped' && <ShipstationFacilityTabs />}
        <ShipstationShipmentToolbar />
        <Divider />
        <ShipstationShipmentTable />
      </Box>
    </Box>
  );
};

export default ShipstationShipmentsView;
